function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#7BE9FC"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.59625,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.02131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.8182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2339 7.19996C17.7862 7.19996 18.2421 7.65049 18.1539 8.19569C18.0769 8.67241 17.9446 9.13968 17.7589 9.58791C17.4453 10.345 16.9857 11.0329 16.4063 11.6123C15.8268 12.1917 15.1389 12.6514 14.3819 12.965C13.6248 13.2786 12.8134 13.44 11.9939 13.44C11.1745 13.44 10.363 13.2786 9.60596 12.965C8.84889 12.6514 8.161 12.1917 7.58156 11.6123C7.00212 11.0329 6.54249 10.345 6.2289 9.58791C6.04324 9.13968 5.91092 8.67241 5.83386 8.19569C5.74573 7.65048 6.20162 7.19996 6.75391 7.19996L11.9939 7.19996H17.2339Z",
  fill: "black"
});

var Svg0PainFree = function Svg0PainFree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg0PainFree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/0_Pain Free.92c83755.svg";
export { ForwardRef as ReactComponent };